import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService.js";
import { uiNotification } from "../../../../services/UINotificationService.js";

export const useDownloadExcel = () => {
  const downloadMutation = useMutation({
    mutationFn: async (selectedIds) => {
      const formData = {
        export_type: "xls",
        export_name: "purchase_order_export",
        selected_ids: selectedIds,
      };

      const response = await http.post("sales/export", formData);
      return response.data;
    },
    onSuccess: (data) => {
      if (data?.data?.file) {
        window.open(
          process.env.REACT_APP_API_URL + "download-data/" + data.data.file,
          "_blank",
        );
      }

      if (data?.message) {
        const languageData =
          JSON.parse(localStorage.getItem("languageData")) || {};
        const globalLang = languageData.global || {};
        uiNotification.success(
          globalLang[data.message] || "Export generated successfully",
        );
      }
    },
    onError: (error) => {
      const result = error?.response?.data;
      const languageData =
        JSON.parse(localStorage.getItem("languageData")) || {};
      const globalLang = languageData.global || {};

      if (result?.message) {
        uiNotification.error(
          globalLang[result.message] || "Unable to export. Try again later",
        );
      } else {
        uiNotification.error("Network error. Please try again.");
      }
    },
  });

  return {
    downloadExcel: downloadMutation.mutate,
    isLoading: downloadMutation.isPending,
    error: downloadMutation.error,
  };
};
